import { $ } from "@/common/Axios";

export default {
  /**
   * 学生综合分数配置
   */
  pointConfig: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * icon 图标 (string query )
     * id  (integer query )
     * operateType 操作类型：自动、班主任录入、班主任申请 (string query )
     * point 分数 (number query )
     * pointType 积分类型：加分、扣分 (string query )
     * subType 子类型 (string query )
     * type 类型 (string query )
     */
    post: (p, c) => $.post("/api/zms/point/pointConfig", p, c),
  },
  pointConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/point/pointConfig/list", p, c),
  },
  pointConfig_listByType: {
    /*
     * 根据类型获取列表
     * operateType 操作类型：自动、班主任录入、班主任申请 (string query )
     * pointType 积分类型：加分、扣分 (string query )
     * type 类型：素质分、学业测评分、积分 (string query )
     */
    get: (p, c) => $.get("/api/zms/point/pointConfig/listByType", p, c),
  },
  pointConfig_listSubType: {
    /*
     * 子类型列表
     * type 类型：素质分、学业测评分、积分 (string query required)
     */
    get: (p, c) => $.get("/api/zms/point/pointConfig/listSubType", p, c),
  },
  pointConfig_listType: {
    /*
     * 类型列表
     */
    get: (p, c) => $.get("/api/zms/point/pointConfig/listType", p, c),
  },

  /**
   * 学生课程
   */
  studentCourse_details: {
    /*
     * 学生详情
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/point/studentCourse/details", p, c),
  },
  studentCourse_downloadFinalScoreModule: {
    /*
     * 期末成绩模板
     */
    get: (p, c) =>
      $.get("/api/zms/point/studentCourse/downloadFinalScoreModule", p, c),
  },
  studentCourse_init: {
    /*
     * 初始化
     * classRoomId 班级id (integer query required)
     * teachingPlanIds 教学计划id (array query required)
     */
    post: (p, c) => $.post("/api/zms/point/studentCourse/init", p, c),
  },
  studentCourse_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/point/studentCourse/list", p, c),
  },
  studentCourse_listSimpleTeachingPlan: {
    /*
     * 简易学生课程列表（初始化过平时分的）
     * schoolRollId 合同id，C端不用传 (integer query )
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/point/studentCourse/listSimpleTeachingPlan", p, c),
  },
  studentCourse_listTerms: {
    /*
     * 学期列表（初始化过平时分的）
     * schoolRollId 合同id，C端不用传 (integer query )
     */
    get: (p, c) => $.get("/api/zms/point/studentCourse/listTerms", p, c),
  },
  studentCourse_setFinalScore: {
    /*
     * 设置期末成绩
     * id id (integer query required)
     * score 成绩 (number query required)
     */
    put: (p, c) => $.put("/api/zms/point/studentCourse/setFinalScore", p, c),
  },
  studentCourse_uploadFinalScore: {
    /*
     * 上传期末成绩
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/zms/point/studentCourse/uploadFinalScore", p, c),
  },

  /**
   * 学生课程记录
   */
  studentCourseRecord: {
    /*
     * 添加
     * configId 配置id (integer query required)
     * operateDate 操作时间 (string query )
     * remark 备注 (string query )
     * schoolRollIds 合同id (array query required)
     * score 分数 (number query )
     * teachingPlanId 教学计划 (integer query required)
     */
    post: (p, c) => $.post("/api/zms/point/studentCourseRecord", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/point/studentCourseRecord", p, c),
  },
  studentCourseRecord_listSimple: {
    /*
     * 简易列表
     * schoolRollId 合同id (integer query )
     * teachingPlanId 教学计划id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/point/studentCourseRecord/listSimple", p, c),
  },

  /**
   * 学生综合分数
   */
  studentPoint_export: {
    /*
     * 学生分数列表导出
     */
    get: (p, c) => $.get("/api/zms/point/studentPoint/export", p, c),
  },
  studentPoint_info: {
    /*
     * 学生积分信息
     * schoolRollId 合同id (integer query )
     */
    get: (p, c) => $.get("/api/zms/point/studentPoint/info", p, c),
  },
  studentPoint_initQualityPointBySchoolRollId: {
    /*
     * 单个初始化学生素质分
     * schoolRollId 合同id (integer query )
     */
    put: (p, c) =>
      $.put("/api/zms/point/studentPoint/initQualityPointBySchoolRollId", p, c),
  },
  studentPoint_initQualityPointBySiteId: {
    /*
     * 初始化学生素质分(根据学校)
     * siteId 学校id (integer query )
     */
    put: (p, c) =>
      $.put("/api/zms/point/studentPoint/initQualityPointBySiteId", p, c),
  },
  studentPoint_list: {
    /*
     * 学生分数列表
     */
    get: (p, c) => $.get("/api/zms/point/studentPoint/list", p, c),
  },
  studentPoint_studentDocument: {
    /*
     * 学生档案
     * schoolRollId 合同id (integer query )
     */
    get: (p, c) => $.get("/api/zms/point/studentPoint/studentDocument", p, c),
  },
  studentPoint_topForStudy: {
    /*
     * 学业测评分排行榜
     * classRoomId 班级id (integer query )
     * limitNum 取多少条 (integer query )
     * siteId 学校 (integer query )
     */
    get: (p, c) => $.get("/api/zms/point/studentPoint/topForStudy", p, c),
  },

  /**
   * 学生综合分数记录
   */
  studentPointRecord: {
    /*
     * 批量删除
     * ids id (array query required)
     */
    delete: (p, c) => $.delete("/api/zms/point/studentPointRecord", p, c),
  },
  studentPointRecord_applyPoint: {
    /*
     * 班主任申请(素质分)
     * attach 附件 (string query )
     * configId 配置id (integer query required)
     * point 分数 (number query )
     * remark 备注 (string query )
     * schoolRollIds 合同id (array query required)
     */
    post: (p, c) =>
      $.post("/api/zms/point/studentPointRecord/applyPoint", p, c),
  },
  studentPointRecord_classReportForStudyPoint: {
    /*
     * 班级报告(学业测评分)
     * classRoomId 班级id (integer query required)
     * endTime 结束时间 (string query required)
     * startTime 开始时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/point/studentPointRecord/classReportForStudyPoint", p, c),
  },
  studentPointRecord_classStatic: {
    /*
     * 班级统计(学业测评分)
     * classRoomId 班级id (integer query required)
     * endTime 结束时间 (string query required)
     * startTime 开始时间 (string query required)
     * type 类型：素质分、学业测评分、积分 (string query required)
     */
    get: (p, c) => $.get("/api/zms/point/studentPointRecord/classStatic", p, c),
  },
  studentPointRecord_classStaticDetail: {
    /*
     * 班级统计(学业测评分)(明细)
     * classRoomId 班级id (integer query required)
     * configId 配置id (integer query )
     * endTime 结束时间 (string query required)
     * startTime 开始时间 (string query required)
     * type 类型：素质分、学业测评分、积分 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/point/studentPointRecord/classStaticDetail", p, c),
  },
  studentPointRecord_enterPoint: {
    /*
     * 班主任录入（学业测评分）
     * attach 附件 (string query )
     * configId 配置id (integer query required)
     * point 分数 (number query )
     * remark 备注 (string query )
     * schoolRollIds 合同id (array query required)
     */
    post: (p, c) =>
      $.post("/api/zms/point/studentPointRecord/enterPoint", p, c),
  },
  studentPointRecord_export: {
    /*
     * 学生分数记录列表导出
     */
    get: (p, c) => $.get("/api/zms/point/studentPointRecord/export", p, c),
  },
  studentPointRecord_list: {
    /*
     * 学生分数记录列表
     */
    get: (p, c) => $.get("/api/zms/point/studentPointRecord/list", p, c),
  },
  studentPointRecord_listDayByClassRoom: {
    /*
     * 根据班级获取学生日分数列表
     * classRoomId 班级id (integer query required)
     * name 学生姓名 (string query )
     * pointDate 积分日期 (string query required)
     * type 类型：素质分、学业测评分、积分 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/point/studentPointRecord/listDayByClassRoom", p, c),
  },
  studentPointRecord_listPoint: {
    /*
     * 班主任端分数列表
     * endTime 结束时间 (string query )
     * schoolRollId 合同id (integer query required)
     * startTime 开始时间 (string query )
     * type 类型：素质分，学业测评分，积分 (string query required)
     */
    get: (p, c) => $.get("/api/zms/point/studentPointRecord/listPoint", p, c),
  },
  studentPointRecord_listPointForClient: {
    /*
     * C端分数列表
     * endTime 结束时间 (string query )
     * startTime 开始时间 (string query )
     * type 类型：素质分，学业测评分，积分 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/point/studentPointRecord/listPointForClient", p, c),
  },
  studentPointRecord_studyInfo: {
    /*
     * 学业测评分信息
     * endTime 结束时间 (string query )
     * startTime 开始时间 (string query )
     */
    get: (p, c) => $.get("/api/zms/point/studentPointRecord/studyInfo", p, c),
  },
};
